import { WpnDateRange, WpnIn, WpnInOut, WpnOut, UserDetails, List, WpnUsers, WpmTypes, WpmTypeUsers, UserWpns } from "../Components/index.js";

export default [
    {
        path: "/report/wpn-in-out",
        component: WpnInOut,
        name: "wpn.in.out",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/report/wpn-out",
        component: WpnOut,
        name: "wpn.out",
        meta: {
            requiresAuth: true,
        },
    },

    {
        path: "/report/wpn-in",
        component: WpnIn,
        name: "wpn.in",
        meta: {
            requiresAuth: true,
        },
    },
    // {path: '/report/wpn-daily', component: WpnDaily, name: 'wpn.daily',

    {
        path: "/report/wpn-date-range",
        component: WpnDateRange,
        name: "wpn.date.range",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/report/user-details/:id",
        component: UserDetails,
        name: "report.user.wpn.details",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/report/wpn-details",
        component: List,
        name: "report.wpn.details",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/report/wpn-users/:id",
        component: WpnUsers,
        name: "report.wpn.users",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/report/wpn-types",
        component: WpmTypes,
        name: "report.wpn.type",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/report/wpn-types/:id",
        component: WpmTypeUsers,
        name: "report.wpn.type.users",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/report/user-wpns",
        component: UserWpns,
        name: "report.user.wpns",
        meta: {
            requiresAuth: true,
        },
    },
];
